import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import StyledModal from '../StyledModal';

const AccountDeleteConfirmModal = ({ isOpen, closeModal }) => {
  const { t } = useTranslation();

  return (
    <StyledModal
      isOpen={isOpen}
      closeModal={() => {
        closeModal();

        // go to root page to cause user to be signed out
        window.location.href = '/';
      }}
      title={t('account.closed.title')}
      cancelButton={{ text: t('common.button_close') }}
    >
      <p>{t('account.closed.description_confirmation')}</p>
    </StyledModal>
  );
};

AccountDeleteConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default AccountDeleteConfirmModal;
